const LeadTestIdsScope = {
  LEAD_INFORMATION_FORM: 'lead-information-form',
};

export const LeadTestIds = {
  LEAD_INFORMATION_FORM_CANCEL_BUTTON: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.cancel-button`,
  LEAD_INFORMATION_FORM_SUBMIT_BUTTON: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.submit-button`,

  // LeadInfo (inline)
  LEAD_INFORMATION_FORM_LEAD_DATA_BUTTON: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.lead-data-button`,

  // LeadInfoEdit.config fields
  LEAD_INFORMATION_FORM_FIRST_NAME_INPUT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.first-name-input`,
  LEAD_INFORMATION_FORM_MIDDLE_NAME_INPUT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.middle-name-input`,
  LEAD_INFORMATION_FORM_LAST_NAME_INPUT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.last-name-input`,
  LEAD_INFORMATION_FORM_SUFFIX_SELECT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.suffix-select`,
  LEAD_INFORMATION_FORM_EMAIL_INPUT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.email-input`,
  LEAD_INFORMATION_FORM_PHONE_INPUT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.phone-input`,
  LEAD_INFORMATION_FORM_CREDIT_RATING_SELECT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.credit-rating-select`,
  LEAD_INFORMATION_FORM_LOAN_PURPOSE_SELECT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.loan-purpose-select`,
  LEAD_INFORMATION_FORM_CHATTEL_PURPOSE_SELECT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.chattel-purpose-select`,
  LEAD_INFORMATION_FORM_CHATTEL_LOCATION_DESCRIPTION_INPUT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.chattel-location-description-input`,
  LEAD_INFORMATION_FORM_CHATTEL_SALES_PRICE_INPUT: `${LeadTestIdsScope.LEAD_INFORMATION_FORM}.chattel-sales-price-input`,
};
